/* eslint-disable array-callback-return */
/* eslint-disable max-len */
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import SummaryInspectionTable from './summaryInspectionTable';
import { RootState } from '../../../redux/rootState';
import {
  CombineReportEnum, PDFReportEnum, ReportPart1,
} from '../helper';
import { SummaryOfInspection } from '../types';

function SummaryInspectionSection() {
  const {
    reportPdfResponse1, reportPdfResponse2a, themePdfColor, tableContent,
  } = useSelector((state:RootState) => state.reportPdfSliceReducer);
  const { BorderColor, MainColor } = themePdfColor;

  const insSummary = useMemo(() => reportPdfResponse2a?.Summary_of_Inspection?.map((item) => ({
    ...item,
    TestType: item?.TestType === 'ADT' ? 'ECT' : item?.TestType,
  })), [reportPdfResponse2a]);

  const totalInsSummary = useMemo(() => {
    const sum: SummaryOfInspection[] = [];
    if (reportPdfResponse2a?.Summary_of_Inspection && reportPdfResponse1?.VesselJobSubArrays) {
      reportPdfResponse1?.VesselJobSubArrays?.map((item) => {
        item?.Vessels?.map((vessel) => {
          const val = insSummary?.find((summary) => (summary?.JobOrder === item?.JobOrder && String(summary?.VesselId) === String(vessel?.VesselId)));
          const jobVal = insSummary?.find((summary) => summary?.JobOrder === item?.JobOrder);
          if (val) {
            sum.push({ ...val, IsNew: vessel?.IsNew });
          } else {
            const DefVal = {
              TestType: vessel?.TestType,
              Defects: [],
              TotalDefects: 0,
              TotalPercentage: 0,
              VesselName: vessel?.VesselName,
              VesselId: String(vessel?.VesselId),
              JobOrder: item?.JobOrder,
              TubeCount: Number(vessel?.TubeCount),
              ReportType: vessel?.ReportType || '',
              SpotTest: vessel?.SpotTest,
              TubesTested: !(vessel?.SpotTest) ? Number(vessel?.TubeCount) : 0,
              SummaryNotes: jobVal?.SummaryNotes || vessel?.Summary || '',
              IsNew: vessel?.IsNew,
            };
            sum.push(DefVal);
          }
        });
      });
    }

    return sum;
  }, [insSummary, reportPdfResponse1]);

  function getTestHeader(value:string) {
    switch (value) {
      case 'ECT':
        return 'An Eddy Current Tube Inspection';
      case 'FLT':
        return 'A Flux Leakage Inspection';
      // case 'ADT':
      //   return 'An Eddy Current Tube Inspection'; as we have mapped ADT=>ECT
      default:
        return '';
    }
  }

  const renderJsx = (details: SummaryOfInspection) => (
    <div className="headingDescriptionText pt20">
      {`${getTestHeader(details?.TestType)} was performed ${details?.ReportType?.length > 0 ? `as part of a ${details?.ReportType}` : ''} with the following results.`}
    </div>
  );
  const renderSummaryNotes = (details: SummaryOfInspection) => (
    <div
      className="headingDescriptionText pt40 pl30 pr30"
      style={{ whiteSpace: 'pre-line' }}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: details?.SummaryNotes }}
    />
  );
  // const renderSummaryNotes = (details: SummaryOfInspection) => {
  //   let sum = details?.SummaryNotes || '';
  //   const jo = details?.JobOrder;

  //   totalInsSummary?.filter((item) => item?.JobOrder === jo)?.map((val) => {
  //     const regex = new RegExp(
  //       `<!--\\s*VESSEL_START:${val?.VesselId}\\s*-->[\\r\\n]*([\\s\\S]*?)[\\r\\n]*<!--\\s*VESSEL_END:${val?.VesselId}\\s*-->`,
  //       'i',
  //     );
  //     const extra = sum.replace(regex, '').trim();
  //     sum = extra;
  //   });
  //   if (sum?.trim()?.length > 0) {
  //     return (
  //       <div
  //         className="headingDescriptionText pt40 pl30 pr30"
  //         style={{ whiteSpace: 'pre-line' }}
  //     // eslint-disable-next-line react/no-danger
  //         dangerouslySetInnerHTML={{ __html: sum }}
  //       />
  //     );
  //   }
  //   return '';
  // };
  const getVesselData = (input: string, vesselId: number | string): string => {
    const regex = new RegExp(
      `<!--\\s*VESSEL_START:${vesselId}\\s*-->[\\r\\n]*([\\s\\S]*?)[\\r\\n]*<!--\\s*VESSEL_END:${vesselId}\\s*-->`,
      'i',
    );

    const match = input.match(regex);
    // const extra = input.replace(regex, '').trim();
    // setExtraSum(extra);
    return match ? match[1].trim() : '';
  };
  const renderVesselSummaryNotes = (details: SummaryOfInspection) => {
    const result = getVesselData(details?.SummaryNotes || '', details?.VesselId);
    if (result?.trim()?.length > 0) {
      return (
        <div
          className="headingDescriptionText pt40 pl30 pr30"
          style={{ whiteSpace: 'pre-line' }}
      // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: `*${result}` }}
        />
      );
    }
    return '';
  };

  return (
    <div className="p10">
      <div className="pageHeader">
        <div className="topHeader">
          <div>
            {ReportPart1(tableContent, CombineReportEnum.COMBINE_SUMMARY_OF_INSPECTION, PDFReportEnum.PDF_SUMMARY_OF_INSPECTION, 'Summary of Inspection')}
          </div>
          <div>{`S/N ${reportPdfResponse2a?.JobOrderData?.SerialNumber}`}</div>
        </div>
        <div className="underlineHeadingText textCenter pb0">Summary of Inspection</div>
        {/* <div className="headingDescriptionText">
          {`${getTestHeader(reportPdfResponse1?.FrontPage?.TestType)} was performed ${reportPdfResponse2?.Summary_of_Inspection?.[0]?.ReportType?.length > 0 ? `as part of a ${reportPdfResponse2?.Summary_of_Inspection?.[0]?.ReportType}` : ''} with the following results.`}
        </div> */}
      </div>
      {totalInsSummary?.map((details, index) => (
        <>

          {(index > 0 && totalInsSummary?.[index]?.TestType !== totalInsSummary?.[index - 1]?.TestType) && <div className="page-break" />}
          {(index === 0 || (index > 0 && totalInsSummary?.[index]?.TestType !== totalInsSummary?.[index - 1]?.TestType)) && renderJsx(details)}
          <div className="pt40">
            <SummaryInspectionTable summaryDetails={details} primaryColor={BorderColor} secondaryColor={MainColor} />
          </div>
          {details?.IsNew && renderVesselSummaryNotes(details)}
          {(index === totalInsSummary.length - 1 || ((index < totalInsSummary.length - 1) && totalInsSummary?.[index]?.JobOrder !== totalInsSummary?.[index + 1]?.JobOrder)) && (details?.IsNew === false) && renderSummaryNotes(details)}
          {/* {(index < reportPdfResponse2.Summary_of_Inspection.length - 1) && <div className="page-break" />} */}
        </>
      ))}
    </div>
  );
}

export default SummaryInspectionSection;
